import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
  standalone: false,
})
export class PaymentModalComponent implements OnInit, OnDestroy {
  @Input() paymentUrl: string = '';
  
  paymentStatus$ = new Subject<{ status: number; url: string }>();
  isLoading = true;
  errorMessage = '';
  safePaymentUrl: SafeResourceUrl = '';
  private urlCheckInterval: any;

  constructor(private modalCtrl: ModalController, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.safePaymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentUrl);
    this.startUrlMonitoring();
  }

  ngOnDestroy() {
    this.stopUrlMonitoring();
  }

  private startUrlMonitoring(): void {
    // Check iframe src periodically
    this.urlCheckInterval = setInterval(() => {
      try {
        const iframe = document.querySelector('iframe') as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
          const iframeUrl = iframe.contentWindow.location.href;
          this.checkPaymentStatus(iframeUrl);
        }
      } catch (error) {
        // Cross-origin iframe - can't access directly
        // Payment gateway will handle redirect
      }
    }, 500);
  }

  private stopUrlMonitoring(): void {
    if (this.urlCheckInterval) {
      clearInterval(this.urlCheckInterval);
      this.urlCheckInterval = null;
    }
  }

  private checkPaymentStatus(url: string): void {
    if (!url) return;

    if (url.indexOf('status=1') > -1) {
      this.paymentStatus$.next({ status: 1, url });
      this.closeModal();
    } else if (url.indexOf('status=0') > -1) {
      this.paymentStatus$.next({ status: 0, url });
      this.closeModal();
    }
  }

  onIframeLoad(): void {
    this.isLoading = false;
  }

  onIframeError(): void {
    this.isLoading = false;
    this.errorMessage = 'Failed to load payment page. Please try again.';
  }

  closeModal(): void {
    this.modalCtrl.dismiss();
  }
}
